import { RECEIVED_COPY } from '../actions/GetCustomCopy';

const initialState = {
    whats_new_title: '',
    whats_new_body: '',
    whats_new_link: '',
};

export default (state = initialState, action) => {
    switch (action.type) {
        case RECEIVED_COPY:
            return action.customCopy;
        default:
            return state;
    }
};
